module.exports = __webpack_public_path__ + "img/TALHADEIRA CURVA PONTA PLANA  - desk.550a4533.png";